import { useThrottleFn } from 'ahooks'
import { useRef } from 'react'

import ScrollService from 'services/Scroll/ScrollService'
import type { ScrollContainerEnum } from 'services/Scroll/enums'

const DEFAULT_BOX = { width: 1, height: 1, x: 1, y: 1 }

export const useDragScroll = (ScrollContainer: ScrollContainerEnum) => {
  const scrollAnchor = useRef(0)

  const onDragStart = (e: React.DragEvent) => (scrollAnchor.current = e.clientY)

  const { run } = useThrottleFn(
    (e: React.DragEvent) => {
      if (!e.clientY) {
        return
      }

      const scroll = ScrollService[ScrollContainer]
      const viewport = scroll?.ref?.getBoundingClientRect() || DEFAULT_BOX
      const safeZone = viewport.height / 4

      if (Math.abs(scrollAnchor.current - e.clientY) > safeZone) {
        scrollAnchor.current = viewport.y + viewport.height / 2
      }

      const speed = Math.abs(Math.abs(e.clientY - scrollAnchor.current) - safeZone)

      scroll?.os?.scrollStop()
      if (e.clientY < scrollAnchor.current - safeZone) {
        scroll?.os?.scroll({ y: `-=${speed}` }, 100, 'linear')
      } else if (e.clientY > scrollAnchor.current + safeZone) {
        scroll?.os?.scroll({ y: `+=${speed}` }, 100, 'linear')
      }
    },
    { wait: 100 },
  )
  return { onDragStart, onDrag: run }
}
